'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  return text.replace(_nonBmpCodePairs2.default, ' ').length;
};

var _nonBmpCodePairs = require('./regexp/nonBmpCodePairs');

var _nonBmpCodePairs2 = _interopRequireDefault(_nonBmpCodePairs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/**
 * Copied from https://github.com/twitter/twitter-text/blob/master/js/twitter-text.js
 */


module.exports = exports['default'];